import * as types from "./mutation_types";

export default {
  [types.ETP_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.ETP_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.ETP_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.ETP_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
